export const AwardsData = [
  { src: "/Award/1.jpg", title: "Campus Event" },
  { src: "/Award/2.jpg", title: "Lab Session" },
  { src: "/Award/3.png", title: "Lab Session" },
  { src: "/Award/4.jpg", title: "Lab Session" },
  { src: "/Award/5.jpg", title: "Lab Session" },
  { src: "/Award/6.jpg", title: "Lab Session" },
];
